<template>
	<ui-form :model="params.data" :transfer-model.sync="submitData" v-slot="{data}">
		<ui-hidden v-model="data.id" autosubmit/>
		<ui-select v-model="data.gradeId" label="年级" url="/admin/grade/list?page=1&limit=100" value-field="id" text-field="name"/>
		<ui-text v-model="data.section" label="章节"/>
		<ui-image :multiple="true" v-model="data.pageList" uploadPath="/admin/common/file/upload" label="课本内容"/>
		<ui-select v-model="data.version" label="版本">
			<ui-option value="1" text="人教版" tag-type="success"/>
			<ui-option value="2" text="苏教版" tag-type="info"/>
		</ui-select>
		<ui-select v-model="data.status" label="状态">
			<ui-option value="1" text="启用" tag-type="success"/>
			<ui-option value="0" text="禁用" tag-type="info"/>
		</ui-select>
		<ui-text v-model="data.sort" label="排序"/>
		<ui-template>
			<ui-button type="submit" @submit="submit"></ui-button>
			<ui-button type="reset" v-if="params.type=='add'"></ui-button>
		</ui-template>
	</ui-form>
</template>

<script>
export default {
	props:['params','close'],
	data(){
		return {
			submitData:{}
		};
	},
	methods:{
		submit(){
			this.$axios.request({url:'/admin/textbook/option',data:this.submitData,method:this.params.type})
			.then(data=>{
				this.close();
			}).end();
		},
	},
}
</script>

<style>
</style>
